import React from 'react';
import { Box } from '@material-ui/core/index';
import { Form, Formik } from 'formik';
import Button from 'src/components/Button';
import BaseModal from 'src/components/Modal/BaseModal';
import {
  Field, ModalSize, Perspective, Widget
} from 'src/types';
import PerspectiveEditor from './PerspectiveEditor';

interface Props {
  widgets: Widget[],
  workflowId: string,
  fields: Field[],
  refreshPerspective: () => void,
  isDragging: boolean,
  onDragStart: () => void,
  onDragStop: (x: number, y: number, z: number) => void,
  onDrop: (layout: any, layoutItem: any, event: any) => void,
  onResizeStop: (x: number, y: number, z: number) => void,
  selectWidget: (widgetId: string) => void,
  title: string,
  maxWidth?: ModalSize,
}

const FormEditor = ({
  widgets,
  workflowId,
  fields,
  refreshPerspective,
  isDragging,
  onDragStart,
  onDragStop,
  onDrop,
  onResizeStop,
  selectWidget,
  title,
  maxWidth,
}: Props) => {
  const fieldByFieldId: Record<string, Field> = {};

  fields.forEach((field: any) => {
    fieldByFieldId[field.id] = field;
  });

  const widgetsWithComponentProps = widgets.map((_widget: any) => {
    if (_widget.fieldId) {
      const field = fieldByFieldId[_widget.fieldId];
      return {
        ..._widget,
        componentProps: {
          name: field.id,
          label: field.name,
          options: field.options,
        }
      };
    }
    return {
      ..._widget,
      componentProps: {},
    };
  });

  const showPlaceholder = !widgetsWithComponentProps.length;

  return (
    <BaseModal
      disableTransition
      title={title}
      maxWidth={maxWidth}
      isOpen
      hideBackdrop
      dialogProps={{
        disableEnforceFocus: true,
        disablePortal: true,
        style: { position: 'absolute' },
        BackdropProps: {
          style: { position: 'absolute' },
        },
      }}
    >
      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <Box height={showPlaceholder ? 300 : null}>
            <PerspectiveEditor
              widgets={widgetsWithComponentProps}
              isDragging={isDragging}
              onDragStart={onDragStart}
              onDragStop={onDragStop}
              onDrop={(layout: any, layoutItem: any, event: any) => {
                onDrop(layout, layoutItem, event);
                refreshPerspective();
              }}
              autoSize={!showPlaceholder}
              fullHeight={showPlaceholder}
              onResizeStop={onResizeStop}
              selectWidget={selectWidget}
              widgetProps={{
                workflowId,
              }}
            />
          </Box>
          <Button look="primary" fullWidth>
            Submit
          </Button>
        </Form>
      </Formik>
    </BaseModal>
  );
};

export default FormEditor;
